import RemoveCouponModalContainer from './RemoveCouponModalContainer';

export default RemoveCouponModalContainer;
